import React, { useState, FormEvent, ChangeEvent } from "react"

const SubscribeForm: React.FC = () => {
  const [email, setEmail] = useState<string>("")
  const [status, setStatus] = useState<"idle" | "success" | "error" | "sending">("idle")
  const [message, setMessage] = useState<string>("")

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    if (!email) {
      setStatus("error")
      setMessage("Please enter a valid email address.")
      return
    }

    setStatus("sending")
    try {
      const formData = new FormData()
      formData.append("EMAIL", email)

      await fetch(
        "https://hamarilabs.us1.list-manage.com/subscribe/post-json?u=18ab00ea8ca9ffad204d2e659&id=21a5c538c7&c=?",
        {
          method: "POST",
          mode: "no-cors",
          body: formData,
        }
      )

      setStatus("success")
      setMessage("Subscription confirmed — welcome to our community!")
      setEmail("")
    } catch (error) {
      setStatus("error")
      setMessage("Something went wrong. Please try again.")
    }
  }

  const handleEmailChange = (e: ChangeEvent<HTMLInputElement>) => {
    setEmail(e.target.value)
  }

  return (
    <form
      onSubmit={handleSubmit}
      className="max-w-md lg:mx-auto"
      noValidate
      aria-label="Subscribe"
    >
      {/* ✅ Only show input and button if not success */}
      {status !== "success" && (
        <>
          <div className="relative w-full mb-4">
            <input
              type="email"
              name="EMAIL"
              id="footer-email"
              required
              placeholder="email address"
              value={email}
              onChange={handleEmailChange}
              aria-label="Email address"
              className="w-full pr-12 pl-4 py-3 border border-gray-300 rounded-sm bg-[#f2f5f9] text-hamariBlue placeholder-black"
            />
            <button
              type="submit"
              aria-label="Subscribe"
              className="absolute right-3 top-1/2 transform -translate-y-1/2 text-lg text-gray-300"
              disabled={status === "sending"}
            >
              ➤
            </button>
          </div>
          <img
            src="https://digitalasset.intuit.com/render/content/dam/intuit/mc-fe/en_us/images/intuit-mc-rewards-text-light.svg"
            alt="Powered by Mailchimp"
            style={{
              width: "70px",
              height: "auto",
              margin: "1rem 0 0 auto",
              display: "block",
            }}
          />
        </>
      )}

      {/* ✅ Always show messages */}
      {status === "success" && (
        <p className="text-white text-xs mt-2 font-semibold">{message}</p>
      )}
      {status === "error" && (
        <p className="text-white text-xs mt-2 font-semibold">{message}</p>
      )}
    </form>
  )
}

export default SubscribeForm
